// extracted by mini-css-extract-plugin
module.exports = {"hero-container":"Hero_hero-container__3Z6Ga","hero-title":"Hero_hero-title__11VfY","hero-img":"Hero_hero-img__1ErIE"};